import React from "react";
import PropTypes from "prop-types";
import { Grid, Box, Card, CardHeader, CardContent, Avatar } from "@mui/material";
import { indigo } from "@mui/material/colors";
import { MdSupportAgent } from "react-icons/md";
import { PatientData } from "../Contexts";
import Messages from "./Messages";
import * as CONST from "../Constants";
import * as API from "../api";

const propTypes = {
  dispatch: PropTypes.func.isRequired,
};
GeneralSupportPage.prototype = propTypes;

export default function GeneralSupportPage(props) {
  const patient = React.useContext(PatientData);
  const [supportMessages, setSupportMessages] = React.useState(null);

  const getSupportMessages = async () => {
    const supportMessages = await API.getSupportMessages();
    if (supportMessages.task_messages) {
      setSupportMessages(supportMessages.task_messages)
    }
  }

  React.useEffect(() => {
    if(supportMessages == null) {
      getSupportMessages().catch(console.error);
    }
  }, [getSupportMessages]);
  return (
    <Grid container direction="row" justifyContent="space-around" alignItems="center">
      <Grid item xs={12}>
        <Card className="patient-feed-card">
          <Box pt={2.5} pb={2} pl={2} pr={2}>
            <CardHeader
              className="cpr"
              avatar={
                <Avatar sx={{ color: indigo[900], bgcolor: "#f6f6f6" }}>
                  <MdSupportAgent />
                </Avatar>
              }
              title={CONST.GENERAL_SUPPORT.TITLE}
              subheader={CONST.GENERAL_SUPPORT.SUBHEADER}
            />
          </Box>

          <CardContent>
            {supportMessages && <Messages showMessages={true} messages={supportMessages} dispatch={props.dispatch} cprId={null} />}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
